import { useCallback, useRef, useState } from "react";
import { Link } from "react-router-dom";
import VisionHero from "../components/vision/VisionHero";
import VisionNarrative from "../components/vision/VisionNarrative";

async function resumeVideo(video, setPlaying) {
  try {
    await video.play();
    setPlaying(true);
  } catch (playbackError) {
    if (playbackError.name !== "AbortError") throw playbackError;
  }
}

export default function VisionPage() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(true);
  const togglePlayback = useCallback(async () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      await resumeVideo(videoRef.current, setPlaying);
      return;
    }
    videoRef.current.pause();
    setPlaying(false);
  }, []);

  return (
    <main className="vision-page" data-testid="vision-page">
      <VisionHero videoRef={videoRef} playing={playing} onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onToggle={togglePlayback} />
      <VisionNarrative />
      <section className="vision-map-cta" data-testid="vision-map-cta"><span className="eyebrow">Proposed campus explorer</span><h2>TRACE THE <em>ECOSYSTEM.</em></h2><Link className="button button--red" to="/campus-map" data-testid="vision-campus-map-link">Explore campus map</Link></section>
    </main>
  );
}